<template>
  <CommunityCard :withHorizontalRules="true">
    <template #header>
      <div class="isim-community-card-header">
        <img src="../assets/groups-mini.svg" alt="groups" />
        <h5>My Groups</h5>
      </div>
    </template>

    <LoadingSpinner v-if="isLoading" :width="50" />

    <ul v-else-if="groups.length" class="list-group list-style-none m-0 my-3">
      <router-link
        v-for="group in groups"
        :key="group.id"
        :to="'/forum/group/' + group.id"
        tag="li"
        :class="{
          'px-3 py-1 list-group-item d-flex': true,
          active: group.id === selectedGroupId,
        }"
      >
        <div class="group-initial">
          {{ group.name[0] }}
        </div>
        <div class="group-title">
          {{ group.name }}
        </div>
      </router-link>
    </ul>
    <p class="text-center info-text">
      Find {{ groups.length ? "more groups" : "a group" }} using the search box
      above!
    </p>
  </CommunityCard>
</template>

<script>
import forumGroupService from "../services/forumgroup.service";
import CommunityCard from "./CommunityCard";
import PleaseWait from "@/components/PleaseWait";
import LoadingSpinner from "@/components/LoadingSpinner";

export default {
  name: "MyGroupsMini",
  props: ["selectedGroupId"],
  components: {
    LoadingSpinner,
    PleaseWait,
    CommunityCard,
  },
  data() {
    return {
      isLoading: false,
      groups: [],
    };
  },
  mounted() {
    this.isLoading = true;

    forumGroupService.myGroups().then((data) => {
      this.groups = data;
      this.isLoading = false;
    });
  },
};
</script>

<style scoped>
ul {
  margin: 1rem;
}

li {
  margin: 0.5rem 0 0.5rem;
}

.list-group-item.active {
  color: var(--isim-primary);
}
@media (min-width: 992px) {
  .list-group-item a {
    color: #333;
  }
}

.list-group-item {
  border: none;
  margin-bottom: 5px;
  color: var(--isim-light-text);
  margin-left: 0;
  background: inherit;
  cursor: pointer;
}

.group-initial {
  width: 24px;
  height: 24px;
  min-width: 24px;
  padding-top: 2px;
  text-align: center;
  color: white;
  border-radius: 50%;
  font-size: 14px;
  background: var(--isim-light-text);
}

.list-group-item.active > .group-initial {
  background: var(--isim-primary);
}

.group-title {
  margin-left: 1rem;
  padding-top: 2px;
}
</style>
